export default __webpack_public_path__ + "static/media/breadcrumb-bg-mob.ece3b5df.png";